import { contentTextCreateSchema, contentTextUpdateSchema } from '@today/models'
import { ContentBodyFormat } from '@today/types'
import { schemaErrors } from './schema-check'

/**
 * The create-text form and the header edit (TO-420 content-admin-ui REQ-003).
 * Bodies are the snake_case wire shape, checked with the API's own schemas.
 */

/** The "Other" source-language choice: the typed `otherLocale` is sent. */
export const OTHER_LOCALE = '__other'

/** `sourceLocale` is `''` (tenant default: omitted), a listed tag, or {@link OTHER_LOCALE}. */
export interface TextFormValues {
	typeCode: string
	code: string
	name: string
	description: string
	sourceLocale: string
	otherLocale: string
	title: string
	body: string
}

export const EMPTY_TEXT_FORM: TextFormValues = {
	typeCode: '',
	code: '',
	name: '',
	description: '',
	sourceLocale: '',
	otherLocale: '',
	title: '',
	body: '',
}

const orNull = (value: string) => value.trim() || null

/** `POST /texts` body; `source_locale` is omitted for the tenant default. */
export const textCreateBody = (values: TextFormValues): Record<string, unknown> => {
	const source = values.sourceLocale === OTHER_LOCALE ? values.otherLocale.trim() : values.sourceLocale
	return {
		type_code: values.typeCode,
		code: values.code.trim(),
		name: values.name,
		description: orNull(values.description),
		...(source ? { source_locale: source } : {}),
		title: values.title,
		body: values.body,
		body_format: ContentBodyFormat.MARKDOWN,
	}
}

export const textCreateErrors = (body: Record<string, unknown>): Record<string, string> =>
	schemaErrors(contentTextCreateSchema, body, 'form')

/** `PATCH /texts/{id}` body: only `name` and `description`. */
export const textHeaderBody = (name: string, description: string): Record<string, unknown> => ({
	name,
	description: orNull(description),
})

export const textHeaderErrors = (body: Record<string, unknown>): Record<string, string> =>
	schemaErrors(contentTextUpdateSchema, body, 'form')
